var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "formatter" }, [
    _c("div", { staticClass: "d-flex gap-5" }, [
      _c(
        "div",
        { staticClass: "editor-row customize-editor-minimize" },
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v("Adding Value"),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Add Value or pick from a variable",
              "show-attributes": true,
              "show-emoji": false,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.add.value,
              callback: function ($$v) {
                _vm.$set(_vm.clone.add, "value", $$v)
              },
              expression: "clone.add.value",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "editor-row customize-editor-minimize" },
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v("Adding Unit Type"),
          ]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: { items: _vm.unitTypes, idKey: "id", labelKey: "label" },
            model: {
              value: _vm.clone.add.unit,
              callback: function ($$v) {
                _vm.$set(_vm.clone.add, "unit", $$v)
              },
              expression: "clone.add.unit",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("FormatPickerInput", {
          attrs: { title: "From Format" },
          model: {
            value: _vm.clone.add.fromFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.add, "fromFormat", $$v)
            },
            expression: "clone.add.fromFormat",
          },
        }),
        _vm._v(" "),
        _c("FormatPickerInput", {
          attrs: { title: "To Format" },
          model: {
            value: _vm.clone.add.toFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.add, "toFormat", $$v)
            },
            expression: "clone.add.toFormat",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("LocalePickerInput", {
          attrs: { title: "From Locale" },
          model: {
            value: _vm.clone.add.fromLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.add, "fromLocale", $$v)
            },
            expression: "clone.add.fromLocale",
          },
        }),
        _vm._v(" "),
        _c("LocalePickerInput", {
          attrs: { title: "To Locale" },
          model: {
            value: _vm.clone.add.toLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.add, "toLocale", $$v)
            },
            expression: "clone.add.toLocale",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }